document.addEventListener("DOMContentLoaded", () => {
  class ProductGridMediaSlider extends HTMLElement {
    constructor() {
      super();

      const observer = new ResizeObserver(() => {
        if (this.flkty) return;

        if (this.closest("div[x-show]")) {
          if (
            getComputedStyle(this.closest("div[x-show]")).display !== "none"
          ) {
            this.initSlider();
          }
        }
      });

      observer.observe(this);
    }

    initSlider() {
      if (this.querySelector("template") == null) {
        this.flkty = new Flickity(this, {
          cellAlign: "left",
          wrapAround: true,
          prevNextButtons: true,
          pageDots: true,
          on: {
            change: (index) => this.onSlideChange(index),
          },
        });
      } else {
        setTimeout(() => {
          // Remove template to prevent Flickity confusion (optional)
          const carousel = document.createElement("div");
          carousel.setAttribute("class", "carousel w-full h-full");
          Array.from(this.children).forEach((child) => {
            if (child.tagName !== "TEMPLATE") {
              const childCln = child.cloneNode(true);
              childCln.querySelector("img").removeAttribute(":src");
              childCln.querySelector("img").removeAttribute(":alt");
              carousel.appendChild(childCln);
              child.remove();
            }
          });
          this.appendChild(carousel);

          this.flkty = new Flickity(carousel, {
            cellAlign: "left",
            wrapAround: true,
            prevNextButtons: true,
            pageDots: true,
            on: {
              change: (index) => this.onSlideChange(index),
            },
          });
        }, 0); // delay to let Alpine populate the DOM
      }
    }

    onSlideChange(index) {
      this.flkty.getCellElements().forEach((el) => {
        const video = el.querySelector("video");
        if (video) {
          const pauseBtn = el.querySelector('[x-ref="pauseBtn"]');
          pauseBtn.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      });

      const el = this.flkty.getCellElements()[index];
      const video = el.querySelector("video");
      if (video) {
        const playBtn = el.querySelector('[x-ref="playBtn"]');
        playBtn.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
          })
        );
      }
    }

    connectedCallback() {
      // Wait for Alpine to render
      requestAnimationFrame(() => {
        // this.initSlider();
      });
    }
  }

  customElements.define("product-grid-media-slider", ProductGridMediaSlider);
});

class ButtonsContainer extends HTMLElement {
  constructor() {
    super();

    this.notToBeRestocked = this.dataset.notToBeRestocked === "true";

    this.BIStrigger = this.querySelector(".BIS_trigger");

    this.init();

    // this.observer = new MutationObserver(() => {
    //   const BISframe = document.querySelector("#back-in-stock-helper-embedded");
    //   if (BISframe) {
    //     this.observer.disconnect();
    //   }

    //   this.init();
    // });

    // this.observer.observe(document.body, {
    //   childList: true,
    //   subtree: true,
    // });
  }

  init() {
    const BISframe = document.querySelector("#back-in-stock-helper-embedded");

    if (
      BISframe &&
      this.BIStrigger &&
      this.BIStrigger.classList.contains("hidden")
    ) {
      this.querySelector(".ATC_trigger").classList.add("hidden");
      if (!this.notToBeRestocked) {
        this.querySelector(".BIS_trigger").classList.remove("hidden");
      }
    }
  }
}
customElements.define("buttons-container", ButtonsContainer);

/* START - UPPERCASE ALL CUSTOMER DATA INPUT (except for email & search) */
document.addEventListener("DOMContentLoaded", () => {
  function onFormInputChange(e) {
    const target = e.target;
    const form = target.closest("form");
    form.querySelectorAll("input").forEach((input) => {
      if (
        input.type === "text" &&
        input.id !== "email" &&
        input.name !== "email" &&
        input.name !== "q"
      ) {
        const uppercasedValue = input.value.toUpperCase();
        if (input.value !== uppercasedValue) {
          input.value = uppercasedValue;
          input.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }
    });
    form.querySelectorAll("textarea").forEach((input) => {
      if (
        input.name !== "custom#brief_introduction_of_customers_company" &&
        input.name !== "custom#message"
      ) {
        const uppercasedValue = input.value.toUpperCase();
        if (input.value !== uppercasedValue) {
          input.value = uppercasedValue;
          input.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }
    });
  }

  const observer = new MutationObserver((mutations, obs) => {
    const formEmbeds = document.querySelectorAll(
      "form-embed, shopify-forms-embed"
    );
    if (formEmbeds.length > 0) {
      formEmbeds.forEach(async (formEmbed) => {
        const success_info = formEmbed.querySelector(
          "section[aria-label='Success']"
        );
        if (success_info) {
          success_info.style.maxWidth = "600px";
        }

        if (!formEmbed.getAttribute("data-random-uuid")) {
          const uuid = crypto.randomUUID();
          formEmbed.setAttribute("data-random-uuid", "form-embed-" + uuid);

          const style = document.createElement("style");
          style.textContent = `
            section[aria-label='Success'] {
              min-width: 500px !important;
            }

            .cdropdown {
              width: 100%;
              padding-left: 11px;
              padding-right: 22px;
              padding-top: var(--form-field-padding-top);
              padding-bottom: var(--form-field-padding-bottom);
              font: var(--forms-body-font);
              background-color: var(--form-background-color);
              color: var(--form-text-color);
              box-shadow: var(--form-field-border);
              border: none;
              outline: none;
              border-radius: var(--form-field-border-radius);
            }
              
            .cdropdown + label {
              pointer-events: none;
              z-index: 1;
              font: var(--forms-body-font);
              line-height: 1;
              color: var(--form-placeholder-color);
              position: absolute;
              left: var(--form-field-padding);
              top: var(--input-label-top);
              max-width: calc(100% - var(--form-field-padding) * 2);
              word-break: keep-all;
              overflow-wrap: break-word;
              margin: 0;
              transform-origin: top left;
              transform: none;
              transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
            }

            .cdropdown:has(option:checked:not([value=""])) + label {
              transform: var(--input-label-transform);
            }
          `;
          formEmbed.shadowRoot.appendChild(style);

          formEmbed.shadowRoot
            .querySelectorAll("form")
            .forEach(async (form) => {
              form.querySelectorAll("input").forEach((input) => {
                input.removeEventListener(
                  "input",
                  onFormInputChange.bind(this)
                );
                input.addEventListener("input", onFormInputChange.bind(this));
              });
              form.querySelectorAll("textarea").forEach((input) => {
                input.removeEventListener(
                  "input",
                  onFormInputChange.bind(this)
                );
                input.addEventListener("input", onFormInputChange.bind(this));
              });

              const observer2 = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (
                    mutation.type === "childList" ||
                    mutation.type === "characterData"
                  ) {
                    form.querySelectorAll("input").forEach((input) => {
                      input.removeEventListener(
                        "input",
                        onFormInputChange.bind(this)
                      );
                      input.addEventListener(
                        "input",
                        onFormInputChange.bind(this)
                      );
                    });
                    form.querySelectorAll("textarea").forEach((input) => {
                      input.removeEventListener(
                        "input",
                        onFormInputChange.bind(this)
                      );
                      input.addEventListener(
                        "input",
                        onFormInputChange.bind(this)
                      );
                    });
                  }
                });
              });

              // Observe changes inside the element
              observer2.observe(form, {
                childList: true, // watch for added/removed elements
                subtree: true, // watch all child elements
                characterData: true, // watch text changes
              });

              /* Start - Render countries & provinces dropdowns */
              const res = await fetch(
                `https://${window.shop_domain}/services/countries.json`
              );
              const data = await res.json();

              const countryField = form.querySelector(
                "#custom\\#address_country"
              );
              const countryCodeField = form.querySelector(
                "#custom\\#address_country_code"
              );
              const provinceField = form.querySelector(
                "#custom\\#address_province"
              );
              const provinceCodeField = form.querySelector(
                "#custom\\#address_province_code"
              );
              if (countryField) {
                countryField.parentElement.style.display = "none";
              }
              if (countryCodeField) {
                countryCodeField.parentElement.style.display = "none";
              }
              if (provinceField) {
                provinceField.parentElement.style.display = "none";
              }
              if (provinceCodeField) {
                provinceCodeField.parentElement.style.display = "none";
              }

              const divC = document.createElement("div");
              divC.style.position = "relative";

              const select = document.createElement("select");
              select.id = "dropdown-countries";
              select.name = "COUNTRY";
              select.classList.add("cdropdown");
              // select.innerHTML =
              //   '<option value="" disabled>Country/Region</option>';

              data.forEach(({ code, name, provinces }) => {
                const option = document.createElement("option");
                option.value = code;
                option.innerHTML = name;
                if (provinces?.length > 1) {
                  option.setAttribute(
                    "data-provinces",
                    JSON.stringify(provinces)
                  );
                }
                select.appendChild(option);
              });

              // select.value = "GB";
              select.value = "";

              if (countryField) {
                // countryField.value = "United Kingdom";
                countryField.value = "";
                countryField.dispatchEvent(
                  new Event("input", { bubbles: true })
                );
              }
              if (countryCodeField) {
                // countryCodeField.value = "GB";
                countryCodeField.value = "";
                countryCodeField.dispatchEvent(
                  new Event("input", { bubbles: true })
                );
              }

              select.addEventListener("change", (e) => {
                const selectedOption = select.querySelector(
                  "option[value='" + e.target.value + "']"
                );

                if (countryField) {
                  countryField.value = selectedOption.textContent;
                  countryField.dispatchEvent(
                    new Event("input", { bubbles: true })
                  );
                }
                if (countryCodeField) {
                  countryCodeField.value = e.target.value;
                  countryCodeField.dispatchEvent(
                    new Event("input", { bubbles: true })
                  );
                }

                let provinces = selectedOption.dataset.provinces;
                if (selectedOption.dataset.provinces) {
                  provinces = JSON.parse(provinces);
                }

                const el = form.querySelector(
                  "#dropdown-provinces"
                )?.parentElement;
                if (el) el.remove();

                provinceField.value = "";
                provinceField.dispatchEvent(
                  new Event("input", { bubbles: true })
                );
                provinceCodeField.value = "";
                provinceCodeField.dispatchEvent(
                  new Event("input", { bubbles: true })
                );

                if (provinces) {
                  const divP = document.createElement("div");
                  divP.style.position = "relative";

                  const selectP = document.createElement("select");
                  selectP.id = "dropdown-provinces";
                  select.name = "PROVINCE";
                  selectP.classList.add("cdropdown");
                  // selectP.innerHTML =
                  //   '<option value="" disabled>Province/State</option>';

                  provinces.forEach(({ code, name }) => {
                    const option = document.createElement("option");
                    option.value = code;
                    option.innerHTML = name;
                    selectP.appendChild(option);
                  });

                  selectP.value = "";

                  if (provinceField) {
                    provinceField.value = "";
                    provinceField.dispatchEvent(
                      new Event("input", { bubbles: true })
                    );
                  }

                  if (provinceCodeField) {
                    provinceCodeField.value = "";
                    provinceCodeField.dispatchEvent(
                      new Event("input", { bubbles: true })
                    );
                  }

                  selectP.addEventListener("change", (e) => {
                    const selectedOption = selectP.querySelector(
                      "option[value='" + e.target.value + "']"
                    );

                    if (provinceField) {
                      provinceField.value = selectedOption.textContent;
                      provinceField.dispatchEvent(
                        new Event("input", { bubbles: true })
                      );
                    }
                    if (provinceCodeField) {
                      provinceCodeField.value = e.target.value;
                      provinceCodeField.dispatchEvent(
                        new Event("input", { bubbles: true })
                      );
                    }

                    if (selectedOption) {
                      let provinces = selectedOption.dataset.provinces;
                      if (selectedOption.dataset.provinces) {
                        provinces = JSON.parse(provinces);
                      }
                    }
                  });

                  divP.appendChild(selectP);
                  divP.insertAdjacentHTML(
                    "beforeend",
                    '<label style="top: 16px;">Province/State</label>'
                  );

                  if (provinceField) {
                    provinceField.parentElement.before(divP);
                  }
                }
              });

              divC.appendChild(select);
              divC.insertAdjacentHTML(
                "beforeend",
                '<label style="top: 16px;">Country/Region</label>'
              );
              if (countryField) {
                countryField.parentElement.before(divC);
              }
              /* End - Render countries & provinces dropdowns */

              const phoneNumberField = form.querySelector("#phone_number");
              const mPhoneNumberField = form.querySelector(
                "#custom\\#phone_number"
              );
              if (mPhoneNumberField) {
                mPhoneNumberField.parentElement.style.display = "none";
              }
              phoneNumberField.addEventListener("input", (e) => {
                mPhoneNumberField.value = e.target.value;
                mPhoneNumberField.dispatchEvent(
                  new Event("input", { bubbles: true })
                );
              });
            });
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.querySelectorAll("form").forEach((form) => {
    form.querySelectorAll("input").forEach((input) => {
      input.removeEventListener("input", onFormInputChange.bind(this));
      input.addEventListener("input", onFormInputChange.bind(this));
    });
    form.querySelectorAll("textarea").forEach((input) => {
      input.removeEventListener("input", onFormInputChange.bind(this));
      input.addEventListener("input", onFormInputChange.bind(this));
    });
  });
});
/* END - UPPERCASE ALL CUSTOMER DATA INPUT (except for email & search) */
